import {
  CAMERA_CORE,
  CAMERA_CONE,
  CAMERA_STATION,
  CAMERA_OLDTOWN,
  CAMERA_HUABO,
  CAMERA_OVERVIEW,
  CAMERA_DEFAULT,
  FOCUS_CORE,
  FOCUS_CONE,
  FOCUS_STATION,
  FOCUS_OLDTOWN,
  FOCUS_HUABO,
  FOCUS_OVERVIEW,
} from "@/utils/point";

/** 大屏演示配置 —— 银川 */

export const DEMO = {
  title: "银川智慧城市",
  subtitle: "三维态势演示系统",
  org: "SMART CITY · YINCHUAN",
};

/** 启动默认视角 */
export { CAMERA_DEFAULT, FOCUS_CORE };

/** 标签抬升：随相机高度 */
function labelLiftFromHeight(h) {
  return Math.min(Math.max((h ?? 2000) * 0.04, 60), 800);
}

function spotWithFocus(key, name, desc, cam, focus, duration) {
  return {
    key,
    name,
    desc,
    ...cam,
    labelLng: focus.lng,
    labelLat: focus.lat,
    labelLift: labelLiftFromHeight(cam.height),
    duration,
  };
}

/**
 * 场景导览点
 * 标签落在相机注视点（画面中心地面），避免偏到相机正下方
 */
export const TOUR_SPOTS = [
  spotWithFocus(
    "core",
    "城市核心区",
    "以光锥为中心的城区骨架",
    CAMERA_CORE,
    FOCUS_CORE,
    2.2
  ),
  spotWithFocus(
    "cone",
    "光锥特效",
    "以光锥为中心的科技特效",
    CAMERA_CONE,
    FOCUS_CONE,
    2.6
  ),
  spotWithFocus(
    "station",
    "银川站",
    "交通枢纽 · 铁路与路网",
    CAMERA_STATION,
    FOCUS_STATION,
    2.4
  ),
  spotWithFocus(
    "oldtown",
    "兴庆老城",
    "道路与水系",
    CAMERA_OLDTOWN,
    FOCUS_OLDTOWN,
    2.2
  ),
  spotWithFocus(
    "huabo",
    "银川市花博园",
    "花卉博览园 · 阅海湾生态",
    CAMERA_HUABO,
    FOCUS_HUABO,
    2.4
  ),
  spotWithFocus(
    "overview",
    "全域俯瞰",
    "以光锥为中心的城市格局",
    CAMERA_OVERVIEW,
    FOCUS_OVERVIEW,
    3
  ),
];

/** 左侧演示指标（静态展示，可后续接真实接口） */
export const DEMO_KPIS = [
  { key: "roads", label: "道路要素", value: "3,087", unit: "条", tip: "主干路网" },
  { key: "builds", label: "建筑轮廓", value: "5,776", unit: "栋", tip: "矢量挤出" },
  { key: "layers", label: "数据图层", value: "6", unit: "层", tip: "可开关" },
  { key: "fx", label: "视觉特效", value: "7", unit: "项", tip: "科技动效" },
];
